import PropTypes from 'prop-types';
import React from 'react';
import UniversalPlayer from 'components/shared/UniversalPlayer';
import { routes } from 'constants/config.js';
import { Icon } from '../ui';

const DocumentViewer = ({ documentId, sourceUrl, url, bssUploadId }) => {
  if (!url && !bssUploadId) {
    return null;
  }

  return bssUploadId ? (
    <div>
      <div className="content">
        <UniversalPlayer
          playerConfigEndpoint={routes.FILE_UPLOAD.BSS.PLAYER_MANIFEST(
            bssUploadId,
          )}
        />
      </div>
      <div className="clearfix">
        <a
          href={sourceUrl}
          className="Document-actionLink"
          target="_blank"
          rel="noreferrer"
        >
          <Icon name="download" />{' '}
          {t('lessons.elements.links.download_original')}
        </a>
      </div>
    </div>
  ) : (
    <div>
      <div className="content">
        <iframe
          title={`preview-document-${documentId}`}
          id={`preview-document-${documentId}`}
          className="Document-preview"
          src={url}
          scrolling="false"
          frameBorder="0"
        />
      </div>
      <div className="clearfix">
        <a
          href={sourceUrl}
          className="Document-actionLink"
          target="_blank"
          rel="noreferrer"
        >
          <Icon name="download" />{' '}
          {t('lessons.elements.links.download_original')}
        </a>
        <a
          href={url}
          className="Document-actionLink"
          target="_blank"
          rel="noreferrer"
        >
          <Icon name="document" />{' '}
          {t('lessons.elements.links.view_full_screen')}
        </a>
      </div>
    </div>
  );
};

DocumentViewer.propTypes = {
  documentId: PropTypes.number,
  url: PropTypes.string,
  sourceUrl: PropTypes.string,
  bssUploadId: PropTypes.string,
};

export default DocumentViewer;
